"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useGetPaginatedData = void 0;
var _configurationManager = require("@ori/configuration-manager");
var _infinite = require("@ori/fetching/infinite");
var _presentationHttp = require("@ori/presentation-http");
var _presentationUtils = require("@ori/presentation-utils");
var _tsUtils = require("@ori/ts-utils");
var _react = require("react");
var _constants = require("../constants");
/* istanbul ignore file @preserve -- api */ const useGetPaginatedData = (param)=>{
    let { getData, data: initialData, appliedFacets, orderBy, pageId, hasFilters } = param;
    const { graphQlNetUrl } = (0, _configurationManager.useServiceUrls)([
        'graphQlNet'
    ]);
    const { headers } = (0, _presentationHttp.useHeaders)();
    const [fetchEnabled, setFetchEnabled] = (0, _react.useState)(false);
    const { isValidating, data = [], size, setSize } = (0, _infinite.useSWRInfinite)((pageIndex)=>{
        const isInitialFetch = pageIndex === 0 && orderBy === _constants.DEFAULT_ORDER_BY && appliedFacets.length === 0;
        const newLoadedRecords = pageIndex * _constants.PAGINATION_LIMIT_ROWS + (isInitialFetch ? _constants.SERVER_PAGINATION_LIMIT_ROWS : 0);
        if (!fetchEnabled) {
            return null;
        }
        return {
            skip: newLoadedRecords,
            limit: isInitialFetch ? _constants.CLIENT_PAGINATION_LIMIT_ROWS : _constants.PAGINATION_LIMIT_ROWS,
            headers,
            graphQlNetUrl,
            orderBy,
            facetFiltering: appliedFacets,
            pageId
        };
    }, getData, {
        // TODO -- Fix type of getRetryErrorSwrOptions
        ...(0, _presentationUtils.getRetryErrorSwrOptions)(),
        revalidateFirstPage: false
    });
    const enableFetch = (0, _react.useCallback)(()=>{
        setFetchEnabled(true);
    }, []);
    (0, _react.useEffect)(()=>{
        if (!fetchEnabled && (orderBy !== _constants.DEFAULT_ORDER_BY || appliedFacets.length > 0)) {
            enableFetch();
        }
    }, [
        appliedFacets.length,
        enableFetch,
        fetchEnabled,
        orderBy
    ]);
    const loadMoreItems = (0, _react.useCallback)(async ()=>{
        enableFetch();
        await setSize((prevSize)=>prevSize + 1);
    }, [
        enableFetch,
        setSize
    ]);
    const content = (0, _react.useMemo)(()=>{
        const rows = [
            orderBy === _constants.DEFAULT_ORDER_BY && appliedFacets.length === 0 ? initialData : null,
            ...data.flatMap((items)=>{
                var _items_filter_map;
                return (_items_filter_map = items === null || items === void 0 ? void 0 : items.filter((item)=>item.__typename === 'EditorialPlpRows').map((item)=>item.content)) !== null && _items_filter_map !== void 0 ? _items_filter_map : [];
            })
        ].filter(_tsUtils.isNonNullable);
        const lastRows = rows.at(-1);
        var _lastRows_totalBannersCount, _lastRows_totalProductsCount, _lastRows_facets, _lastRows_orderByOptions;
        return {
            rows: rows.flatMap((item)=>item.rows).filter(_tsUtils.isNonNullable),
            totalBannersCount: (_lastRows_totalBannersCount = lastRows === null || lastRows === void 0 ? void 0 : lastRows.totalBannersCount) !== null && _lastRows_totalBannersCount !== void 0 ? _lastRows_totalBannersCount : 0,
            totalProductsCount: (_lastRows_totalProductsCount = lastRows === null || lastRows === void 0 ? void 0 : lastRows.totalProductsCount) !== null && _lastRows_totalProductsCount !== void 0 ? _lastRows_totalProductsCount : 0,
            facets: (_lastRows_facets = lastRows === null || lastRows === void 0 ? void 0 : lastRows.facets) !== null && _lastRows_facets !== void 0 ? _lastRows_facets : [],
            orderByOptions: (_lastRows_orderByOptions = lastRows === null || lastRows === void 0 ? void 0 : lastRows.orderByOptions) !== null && _lastRows_orderByOptions !== void 0 ? _lastRows_orderByOptions : []
        };
    }, [
        appliedFacets.length,
        data,
        initialData,
        orderBy
    ]);
    return (0, _react.useMemo)(()=>{
        var _content_rows;
        return {
            isLoadingMore: size > 0 && isValidating,
            isRefreshing: ((_content_rows = content.rows) === null || _content_rows === void 0 ? void 0 : _content_rows.length) === 0 && isValidating || !!hasFilters && !fetchEnabled,
            enableFetch,
            loadMoreItems,
            content
        };
    }, [
        size,
        isValidating,
        content,
        hasFilters,
        fetchEnabled,
        enableFetch,
        loadMoreItems
    ]);
};
exports.useGetPaginatedData = useGetPaginatedData;
